<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import NavBar from './components/layout/NavBar.vue'
import Footer from './components/layout/Footer.vue'
import { useAuthStore } from './stores/auth'

const authStore = useAuthStore()

// Check reward eligibility on app load for authenticated users
onMounted(() => {
  if (authStore.isAuthenticated) {
    authStore.checkRewardEligibility()
  }
})
</script>

<template>
  <div class="min-h-screen flex flex-col bg-surface-500">
    <NavBar />
    <main class="flex-grow">
      <RouterView />
    </main>
    <Footer />
  </div>
</template>
